import { Injectable } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { SplitText } from 'gsap-trial/all';

@Injectable({
  providedIn: 'root',
})
export class AnimationService {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    // gsap.registerPlugin(SplitText)
  }

  // animation.service.ts

  // Immediate in-view animation - triggers as soon as element enters viewport
  fadeInElementsImmediate(elements: any[], delay: number): void {
    elements.forEach((element, index) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.2,
          ease: 'power2.out',
          delay: index * delay,
          scrollTrigger: {
            trigger: element,
            start: 'top 100%',
            end: 'top 50%',
            scrub: false,
            toggleActions: 'play none none reverse',
            fastScrollEnd: true,
            invalidateOnRefresh: true,
            markers: false,
          },
        }
      );
    });
  }

  fadeInElements(elements: any[], delay: number): void {
    elements.forEach((element, index) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          ease: 'power2.out',
          delay: index * delay,
          scrollTrigger: {
            trigger: element,
            start: 'top 100%',
            end: 'top 0%',
            scrub: false,
            toggleActions: 'play none none reverse',
            fastScrollEnd: true,
            invalidateOnRefresh: true,
            markers: false,
          },
        }
      );
    });
  }

  fadeOutElementsOnScroll(elements: any[]): void {
    elements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 1,
          y: 0,
        },
        {
          opacity: 0,
          y: -100,
          duration: 0.3,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: element,
            start: 'top 10%',
            end: 'top -10%',
            toggleActions: 'play none none reverse',
            fastScrollEnd: true,
            invalidateOnRefresh: true,
            markers: false,
          },
        }
      );
    });
  }

  revelText(elements: any[]): void {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: elements[0],
        start: 'top 85%',
        end: 'top 20%',
        toggleActions: 'play none none reverse',
        fastScrollEnd: true,
        invalidateOnRefresh: true,
        markers: false,
      },
    });

    tl.fromTo(
      elements,
      { x: -100, opacity: 0 },
      { x: 0, opacity: 1, stagger: 0.1, duration: 0.3, ease: 'power2.out' }
    );
  }

  revelTextRight(elements: any[]): void {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: elements[0],
        start: 'top 85%',
        end: 'top 20%',
        toggleActions: 'play none none reverse',
        fastScrollEnd: true,
        invalidateOnRefresh: true,
        markers: false,
      },
    });

    tl.fromTo(
      elements,
      { x: 100, opacity: 0 },
      { x: 0, opacity: 1, stagger: 0.1, duration: 0.3, ease: 'power2.out' }
    );
  }
  reveal() {
    let revealContainers = document.querySelectorAll('.right');
    if (revealContainers) {
      revealContainers.forEach((container) => {
        let image = container.querySelector('img');
        let topLine = container.querySelector('.top-line');
        let bottomLine = container.querySelector('.bottom-line');
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            toggleActions: 'restart none none reset',
          },
        });

        // Top line walks from left into position
        if (topLine) {
          tl.fromTo(topLine, 
            { x: '-100%' },
            { x: '0%', duration: 1.0, ease: 'none' },
            0
          );
        }
        // Bottom line walks from right into position
        if (bottomLine) {
          tl.fromTo(bottomLine, 
            { x: '100%' },
            { x: '0%', duration: 1.0, ease: 'none' },
            0
          );
        }
        // Image reveals like a line (draws in from top to bottom)
        if (image) {
          tl.fromTo(image, 
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0% 0)', duration: 1.0, ease: 'none' },
            0
          );
        }
      });
    }
  }

  revealLeft() {
    let revealContainers = document.querySelectorAll('.left');
    if (revealContainers) {
      revealContainers.forEach((container) => {
        let image = container.querySelector('img');
        let topLine = container.querySelector('.top-line');
        let bottomLine = container.querySelector('.bottom-line');
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            toggleActions: 'restart none none reset',
          },
        });

        // Top line walks from left into position
        if (topLine) {
          tl.fromTo(topLine, 
            { x: '-100%' },
            { x: '0%', duration: 1.0, ease: 'none' },
            0
          );
        }
        // Bottom line walks from right into position
        if (bottomLine) {
          tl.fromTo(bottomLine, 
            { x: '100%' },
            { x: '0%', duration: 1.0, ease: 'none' },
            0
          );
        }
        // Image reveals like a line (draws in from top to bottom)
        if (image) {
          tl.fromTo(image, 
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0% 0)', duration: 1.0, ease: 'none' },
            0
          );
        }
      });
    }
  }
}
